<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.125 0.25H2.375C1.87772 0.25 1.40081 0.447544 1.04917 0.799175C0.697544 1.15081 0.5 1.62772 0.5 2.125L0.5 15.875C0.5 16.3723 0.697544 16.8492 1.04917 17.2008C1.40081 17.5525 1.87772 17.75 2.375 17.75H7.73633V11.8004H5.27539V9H7.73633V6.86562C7.73633 4.43789 9.18164 3.09687 11.3953 3.09687C12.4555 3.09687 13.5641 3.28594 13.5641 3.28594V5.66875H12.3426C11.1391 5.66875 10.7637 6.41562 10.7637 7.18164V9H13.4504L13.0207 11.8004H10.7637V17.75H16.125C16.6223 17.75 17.0992 17.5525 17.4508 17.2008C17.8025 16.8492 18 16.3723 18 15.875V2.125C18 1.62772 17.8025 1.15081 17.4508 0.799175C17.0992 0.447544 16.6223 0.25 16.125 0.25Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
